import React from "react";

const Home = () => {
  return (
    <div>
      <h2>Welcome to Our Website</h2>
      <p>This is the home page of our website.</p>
    </div>
  );
};

export default Home;
